import firebaseAPI from 'firebase'
import firebaseUi from 'firebaseui'
require('firebase/firestore')

var config = {
  apiKey: "AIzaSyDY5Khn2lNb4enKHCGNB9TdOT2Dt0QqNOw",
  authDomain: "youth-updates.firebaseapp.com",
  databaseURL: "https://youth-updates.firebaseio.com",
  projectId: "youth-updates",
  storageBucket: "youth-updates.appspot.com",
  messagingSenderId: "854830387377"
};

// Initiailize the firebase App
firebaseAPI.initializeApp(config)

// Initialize the FirebaseUI Widget using Firebase.
var ui = new firebaseUi.auth.AuthUI(firebaseAPI.auth())

// Firestore config
var firestoreDatabase = firebaseAPI.firestore();
firestoreDatabase.enablePersistence()
  .then(function () {
    // console.log("Persistence Enabled")
  })
  .catch(function (err) {
    if (err.code == 'failed-precondition') {
      // Multiple tabs open, persistence can only be enabled
      // in one tab at a a time.
      // ...
      console.error("offline storage can't function when two tabs are open")
    } else if (err.code == 'unimplemented') {
      // The current browser does not support all of the
      // features required to enable persistence
      // ...
      console.error("offline storage not supported")
    }
  });

export const firebase = firebaseAPI
export const signInUi = ui
export const firestore = firestoreDatabase
export const storage = firebaseAPI.storage()
